import { OpaqueToken } from '@angular/core';

// import translations
import { LANG_EN_NAME, LANG_EN_CODE, LANG_EN_COMPLETE_NAME, LANG_EN_TRANS } from './i18n/lang-en';
import { LANG_ES_NAME, LANG_ES_CODE, LANG_ES_COMPLETE_NAME, LANG_ES_TRANS } from './i18n/lang-es';
import { LANG_DA_NAME, LANG_DA_CODE, LANG_DA_COMPLETE_NAME, LANG_DA_TRANS } from './i18n/lang-da';
import { LANG_FR_NAME, LANG_FR_CODE, LANG_FR_COMPLETE_NAME, LANG_FR_TRANS } from './i18n/lang-fr';
import { LANG_DE_NAME, LANG_DE_CODE, LANG_DE_COMPLETE_NAME, LANG_DE_TRANS } from './i18n/lang-de';
import { LANG_CA_NAME, LANG_CA_CODE, LANG_CA_COMPLETE_NAME, LANG_CA_TRANS } from './i18n/lang-ca';
import { LANG_NL_NAME, LANG_NL_CODE, LANG_NL_COMPLETE_NAME, LANG_NL_TRANS } from './i18n/lang-nl';

// translation token
export const TRANSLATIONS = new OpaqueToken('translations');

// all translations
export const dictionary = {
  [LANG_EN_CODE]: LANG_EN_TRANS,
  [LANG_ES_CODE]: LANG_ES_TRANS,
  [LANG_DA_CODE]: LANG_DA_TRANS,
  [LANG_FR_CODE]: LANG_FR_TRANS,
  [LANG_DE_CODE]: LANG_DE_TRANS,
  // [LANG_CA_CODE]: LANG_CA_TRANS,
  [LANG_NL_CODE]: LANG_NL_TRANS,
};

// all the languages
export const LANGUAGES = [
  {
    key: LANG_EN_NAME,
    code: LANG_EN_CODE,
    name: LANG_EN_COMPLETE_NAME
  },
  {
    key: LANG_ES_NAME,
    code: LANG_ES_CODE,
    name: LANG_ES_COMPLETE_NAME
  },
  {
    key: LANG_DA_NAME,
    code: LANG_DA_CODE,
    name: LANG_DA_COMPLETE_NAME
  },
  {
    key: LANG_FR_NAME,
    code: LANG_FR_CODE,
    name: LANG_FR_COMPLETE_NAME
  },
  {
    key: LANG_DE_NAME,
    code: LANG_DE_CODE,
    name: LANG_DE_COMPLETE_NAME
  },
  // {
  //   key: LANG_CA_NAME,
  //   code: LANG_CA_CODE,
  //   name: LANG_CA_COMPLETE_NAME
  // },
  {
    key: LANG_NL_NAME,
    code: LANG_NL_CODE,
    name: LANG_NL_COMPLETE_NAME
  }
];

// providers
export const TRANSLATION_PROVIDERS = [
  { provide: TRANSLATIONS, useValue: dictionary }
];



// WEBPACK FOOTER //
// ./src/app/translation/translation.ts